/*GALERIA FLEX*/
var jquery = require('jquery');
(function () {
    var __countRow = 0;

    jquery.fn.flexImages = function (options) {
        var o = jquery.extend({ container: '.item', object: 'img', rowHeight: 180, maxRows: 0, truncate: 0, miniatures: true, big: false }, options);
        return this.each(function () {
            var grid = jquery(this);
            var containers = jquery(grid).find(o.container), items = [], t = new Date().getTime();
            //var s = window.getComputedStyle ? getComputedStyle(containers[0], null) : containers[0].currentStyle;
            //o.margin = (parseInt(s.marginLeft) || 0) + (parseInt(s.marginRight) || 0) + (Math.round(parseFloat(s.borderLeftWidth)) || 0) + (Math.round(parseFloat(s.borderRightWidth)) || 0);
            o.margin = 12;
            o.class = 'ficha_foto flex-image n item';
            for (var j = 0; j < containers.length; j++) {
                var c = containers[j];
                var obj = jquery(c).find(o.object);
                var img = obj[0];
                var width, height;
                if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
                    width = img.naturalWidth;
                    height = img.naturalHeight;
                } else {
                    width = c.getAttribute('data-w');
                    height = c.getAttribute('data-h');
                    if (!width || width === '0') { width = 400; }
                    if (!height || height === '0') { height = 400; }
                }
                var norm_w = width * (o.rowHeight / parseInt(height)); // normalized width
                items.push([c, width, norm_w, obj, obj.data('src')]);
            }
            if (!o.big) {
                makeGrid(grid, items, o);
            }
            jquery(window).off('resize.flexImages' + grid.data('flex-t'));
            jquery(window).on('resize.flexImages' + t, function () {
                if (!o.big) {
                    makeGrid(grid, items, o);
                }
            });
            grid.data('flex-t', t);
        });
    };

    function makeGrid(grid, items, o) {
        __countRow = 0;

        var x, new_w, ratio = 1, rows = 1, max_w = grid.width() - 2, row = [], row_width = 0, row_h = o.rowHeight, h;
        var __maxRow = 2;
        if (!max_w) max_w = grid.width() - 2; // IE < 8 bug

        // define inside makeGrid to access variables in scope
        function _helper(lastRow) {

            if (!o.minitarues && o.maxRows && rows > o.maxRows || !o.minitarues && o.truncate && lastRow && rows > 1) {
                row[x][0].style.display = 'none';
            } else {

                if (row[x][4]) { row[x][3].attr('src', row[x][4]); row[x][4] = ''; }
                if (o.className !== '') { row[x][0].className = o.class; }
                row[x][0].style.width = new_w + 'px';
                row[x][0].style.height = row_h + 'px';
                row[x][0].style.display = 'block';
            }
        }

        function _verifyMiniature() {
            if (o.miniatures && __countRow >= __maxRow) {
                o.class = 'ficha_foto flex-image p item';
                row_h = 60;
                new_w = 80;
            } else {
                o.class = 'ficha_foto flex-image n item';
            }
        }
        for (var i = 0; i < items.length; i++) {


            row.push(items[i]);
            row_width += items[i][2] + o.margin;
            if (row_width >= max_w) {
                var exact_w;
                var margins_in_row = row.length * o.margin;
                ratio = (max_w - margins_in_row) / (row_width - margins_in_row), row_h = Math.ceil(o.rowHeight * ratio), exact_w = 0, new_w;
                for (x = 0; x < row.length; x++) {
                    new_w = Math.ceil(row[x][2] * ratio);
                    exact_w += new_w + o.margin;
                    if (exact_w > max_w) new_w -= exact_w - max_w;
                    _verifyMiniature();
                    _helper();

                }
                // reset for next row
                row = [], row_width = 0;
                __countRow += 1;

                rows++;
            }
        }
        // layout last row - match height of last row to previous row
        for (x = 0; x < row.length; x++) {
            new_w = Math.floor(row[x][2] * ratio), h = Math.floor(o.rowHeight * ratio);
            _helper(true);
        }

    }
})();
